import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { colors, getResetByTag, utilityStyles, rem } from './../../styles';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1jhc3eq",
  styles: "background:none;display:flex;flex-direction:column;transition:border-top,0.26ms,linear;width:100%"
} : {
  name: "mqzp2w-defaultStyles",
  styles: "background:none;display:flex;flex-direction:column;transition:border-top,0.26ms,linear;width:100%;label:defaultStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var defaultStyles = function defaultStyles() {
  return _ref;
};
var hasBorderStyles = function hasBorderStyles(_ref2) {
  var hasBorder = _ref2.hasBorder;
  if (hasBorder === true) {
    return /*#__PURE__*/css("border:", rem(1), " solid ", colors.coolGray_500, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:hasBorderStyles;"));
  }
};

// fills for border left / top
var fills = {
  blue: colors.lightBlue_500,
  coral: colors.coral_700,
  gray: colors.coolGray_300,
  green: colors.green_500,
  navy: colors.blue_900,
  red: colors.red_500,
  violet: colors.purple_500,
  yellow: colors.yellow_500
};
fills.indigo = fills.navy;
fills.orange = fills.coral;
var borderTopStyles = function borderTopStyles(_ref3) {
  var borderTop = _ref3.borderTop;
  if (fills[borderTop]) {
    return /*#__PURE__*/css("border-top:", rem(4), " solid ", fills[borderTop], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:borderTopStyles;"));
  }
};
var borderLeftStyles = function borderLeftStyles(_ref4) {
  var borderLeft = _ref4.borderLeft;
  if (fills[borderLeft]) {
    return /*#__PURE__*/css("border-left:", rem(4), " solid ", fills[borderLeft], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:borderLeftStyles;"));
  }
};
var variantStyles = function variantStyles(_ref5) {
  var variant = _ref5.variant;
  switch (variant) {
    case 'gray':
      return /*#__PURE__*/css("background-color:", colors.coolGray_100, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'cool-gray':
      return /*#__PURE__*/css("background-color:", colors.coolGray_200, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'white':
      return /*#__PURE__*/css("background-color:", colors.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'dark':
      return /*#__PURE__*/css("background-color:", colors.navy_500, ";color:", colors.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'brand':
      return /*#__PURE__*/css("background-color:", colors.blue_500, ";color:", colors.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'transparent':
      return /*#__PURE__*/css("box-shadow:none;background-color:", colors.transparent, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
  }
};
var isInverseStyles = function isInverseStyles(_ref6) {
  var isInverse = _ref6.isInverse;
  if (isInverse === true) {
    return /*#__PURE__*/css("background-color:", colors.navy_400, ";color:", colors.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:isInverseStyles;"));
  }
};
var resetStyles = getResetByTag('div');
var StyledTile = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e11fhfnn0"
} : {
  target: "e11fhfnn0",
  label: "StyledTile"
})(resetStyles, defaultStyles, hasBorderStyles, borderTopStyles, borderLeftStyles, variantStyles, isInverseStyles, utilityStyles);
export default StyledTile;